import { createResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_SERVICEDESK_ATLASSIAN_ANALYTICS } from './constants.tsx';
import type { ResourceData } from './types.tsx';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-servicedesk-atlassian-analytics", jiraSpaEntry: "async-resource-servicedesk-atlassian-analytics" */ './controllers/get-data'
	);

export const servicedeskAtlassianAnalyticsResource = createResource<ResourceData>({
	type: RESOURCE_TYPE_SERVICEDESK_ATLASSIAN_ANALYTICS,
	getKey: () => 'atlassian analytics',
	getDataLoader,
	isBrowserOnly: true,
});
